// Libraries
var React = require('react');
var $ = require('jquery');

// Styles
require('./BarChart.scss');

class BarChart extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			width: 0,
			data: {}
		}
	}

	componentDidMount() {
		if (this.props.data) {
			this.setState({ data: this.props.data });

			if (this.props.data.values && this.props.data.values.length > 0) {
				$(document).ready(() => {
					// delay until document is ready to see the change of width animated
					this.setState({ width: this.generatePercentage(this.props.data.values) });
				});
			}
		}
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.data !== nextProps.data) {
			this.setState({ data: nextProps.data });

			if (this.props.data.values && this.props.data.values.length > 0) {
				this.setState({ width: this.generatePercentage(this.props.data.values) });
			}
		}
	}

	generatePercentage = (data) => {
		if ((data[0] === 0 && data[1] === 0) || (data[0] === data[1])) {
			return 50;
		} else {
			let total = data[0] + data[1];
			return data[0] / total * 100;
		}
	}

	render() {
		return (
			<div className="BarChart">
				{this.state.data && this.state.data.values &&
						<div className="BarChart__wrapper" tabIndex="0">
							<p className="BarChart__title">{this.state.data.title}</p>
							<div className="BarChart__bar" style={{backgroundColor: this.props.awayColour}}>
								<div className="BarChart__bar--progress" style={{ width: this.state.width + "%", backgroundColor: this.props.homeColour }}></div>
							</div>
							<p className="BarChart__values--left" aria-label={this.props.ariaDescriptionHome}>{this.state.data.values[0]}</p>
							<p className="BarChart__values--right" aria-label={this.props.ariaDescriptionAway}>{this.state.data.values[1]}</p>
						</div>
				}
			</div>
		)
	}
}

module.exports = BarChart;



// WEBPACK FOOTER //
// ./src/common/BarChart/BarChart.js